import { Box } from "@mui/material";
import DatesPicker from "./components/DatesPicker";
import Logs from "./components/Logs";
import { useState } from "react";

const ClientLogs = () => {
    const [dates, setDates] = useState({
        startDate: null,
        endDate: null,
    });
    const handleDateChange = (startDate, endDate) => {
        setDates({
            startDate,
            endDate,
        });
    };
    return (
        <Box
            sx={{
                flexGrow: 1,
                marginTop: 3,
                marginLeft: 0,
                marginRight: 3,
                marginBottom: 3,
                maxWidth: 1140,
            }}
        >
            <DatesPicker
                onChange={handleDateChange}
                initialEndDate={new Date()}
                required={true}
            />
            <Logs startDate={dates.startDate} endDate={dates.endDate} />
        </Box>
    );
};

export default ClientLogs;
